import React, { Component, Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import CssBaseline from '@material-ui/core/CssBaseline';
import withTracker from './hocs/withTracker';
import Service from './views/Service';
import Login from './views/Login';
import Register from './views/Register';
import BuyAgain from './views/BuyAgain';
import TryAgain from './views/TryAgain';
import CreateTicket from './views/CreateTicket';
import OrderConfirmed from './views/OrderConfirmed';
import AdhocOrderConfirmed from './views/AdhocOrderConfirmed';
import BankOrderConfirmed from './views/BankOrderConfirmed';
import ViewTickets from './views/ViewTickets';
import Account from './views/Account';
import Header from './components/Header';
import Footer from './components/Footer';
import AuthenticatedRoute from './components/AuthenticatedRoute';
import UnauthenticatedRoute from './components/UnauthenticatedRoute';
import TicketDetail from './views/TicketDetail';
import TicketNotifications from './views/TicketNotifications';
import ForgotPassword from './views/ForgotPassword';
import CreateMandate from './views/CreateMandate';
import MandateConfirmed from './views/MandateConfirmed';
import TicketSent from './views/TicketSent';
import TicketSmsSent from './views/TicketSmsSent';
import RenewTicket from './views/RenewTicket';
import RenewalConfirmed from './views/RenewalConfirmed';
import Help from './views/Help';
import WaitingList from './views/WaitingList';
import Trips from './views/Trips';
import TopUp from './views/TopUp';
import TopUpConfirmed from './views/TopUpConfirmed';
import MultiServiceSelector from './views/MultiServiceSelector';
import BookingConfirmed from './views/BookingConfirmed';
import MultiServiceSelectorExistingTicket from './views/MultiServiceSelectorExistingTicket';
import Bookings from './views/Bookings';
import ChangeBooking from './views/ChangeBooking';
import './Skin.css';

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAuthenticating: true,
            isAuthenticated: false
        };
    }

    async componentDidMount() {
        try {
            await Auth.currentSession();
            this.handleAuth(true);
        } catch (e) {
            if (e !== 'No current user') {
                console.error(e);
            }
        }

        this.setState({ isAuthenticating: false });
    }

    handleAuth = authenticated => {
        this.setState({
            isAuthenticated: authenticated
        });
    };

    render() {
        const { isAuthenticating, isAuthenticated } = this.state;
        const childProps = {
            isAuthenticated,
            userHasAuthenticated: this.userHasAuthenticated,
            handleAuth: this.handleAuth
        };
        return (
            !isAuthenticating && (
                <Fragment>
                    <CssBaseline />
                    <div className="App">
                        <Header
                            isAuthenticated={isAuthenticated}
                            handleAuth={this.handleAuth}
                        />
                        <Route path="/help" component={withTracker(Help)} />
                        <Route path="/contact" component={withTracker(Help)} />
                        <AuthenticatedRoute
                            path="/"
                            component={withTracker(ViewTickets)}
                            props={childProps}
                            exact
                        />
                        <AuthenticatedRoute
                            path="/account"
                            component={withTracker(Account)}
                            props={childProps}
                            exact
                        />
                        <AuthenticatedRoute
                            path="/ticket/:ticketId/notifications"
                            component={withTracker(TicketNotifications)}
                            props={childProps}
                            exact
                        />
                        <AuthenticatedRoute
                            path="/ticket/:ticketId"
                            component={withTracker(TicketDetail)}
                            props={childProps}
                            exact
                        />
                        <AuthenticatedRoute
                            path="/booking/:pk/:sk"
                            component={withTracker(ChangeBooking)}
                            exact
                            props={childProps}
                        />
                        <Switch>
                            <AuthenticatedRoute
                                path="/book/:customerTicketId"
                                component={withTracker(
                                    MultiServiceSelectorExistingTicket
                                )}
                                exact
                                props={childProps}
                            />
                            <AuthenticatedRoute
                                path="/client/:clientSlug/advance"
                                component={withTracker(MultiServiceSelector)}
                                exact
                                props={childProps}
                            />
                            <Route
                                path="/client/:clientSlug/:serviceId"
                                component={withTracker(Service)}
                            />
                        </Switch>
                        <AuthenticatedRoute
                            path="/booking-confirmed/:customerTicketId/:year/:clientSlug"
                            component={withTracker(BookingConfirmed)}
                            exact
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            path="/ticket/:customerTicketId/bookings"
                            component={withTracker(Bookings)}
                            exact
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            path="/create-ticket/:year/:clientSlug/:serviceId/:ticketId"
                            component={withTracker(CreateTicket)}
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            path="/buy-again/:year/:clientId/:serviceId/:ticketId/:oldCustomerTicketId"
                            component={withTracker(BuyAgain)}
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            path="/try-again/:encryptedTicketId"
                            component={withTracker(TryAgain)}
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            path="/renew/:renewalId"
                            component={withTracker(RenewTicket)}
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            path="/create-mandate/:year/:clientId/:serviceId/:ticketId"
                            component={withTracker(CreateMandate)}
                            props={childProps}
                            exact
                        />
                        <AuthenticatedRoute
                            path="/create-renewal-mandate/:clientId/:renewalId"
                            component={withTracker(CreateMandate)}
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            path="/mandate-confirmed/:year/:clientSlug/:serviceId/:ticketId/:sessionId"
                            component={withTracker(MandateConfirmed)}
                            props={childProps}
                            exact
                        />
                        <AuthenticatedRoute
                            path="/mandate-renewal-confirmed/:clientSlug/:renewalId/:sessionId"
                            component={withTracker(MandateConfirmed)}
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            path="/order-confirmed/adhoc/:customerTicketId/:year/:clientId/:clientSlug/:serviceId/:ticketId"
                            component={withTracker(AdhocOrderConfirmed)}
                            exact
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            path="/order-confirmed/:customerTicketId/:year/:clientSlug/:serviceId/:ticketId"
                            component={withTracker(OrderConfirmed)}
                            exact
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            path="/order-confirmed/:customerTicketId"
                            component={withTracker(OrderConfirmed)}
                            exact
                            props={childProps}
                        />
                        <Route
                            path="/bank-order-confirmed"
                            component={withTracker(BankOrderConfirmed)}
                            exact
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            path="/renewal-confirmed/:ticketId"
                            component={withTracker(RenewalConfirmed)}
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            exact
                            path="/ticket/:ticketId/sent"
                            component={withTracker(TicketSent)}
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            exact
                            path="/ticket/:ticketId/sms-sent"
                            component={withTracker(TicketSmsSent)}
                            props={childProps}
                        />
                        <UnauthenticatedRoute
                            path="/login"
                            component={withTracker(Login)}
                            props={childProps}
                        />
                        <UnauthenticatedRoute
                            path="/register"
                            component={withTracker(Register)}
                            props={childProps}
                        />
                        <UnauthenticatedRoute
                            path="/forgot-password"
                            component={withTracker(ForgotPassword)}
                            props={childProps}
                        />
                        <Route
                            exact
                            path="/waiting-list/:clientSlug/"
                            component={withTracker(WaitingList)}
                            props={childProps}
                        />
                        <Route
                            path="/waiting-list/:year/:clientSlug/"
                            component={withTracker(WaitingList)}
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            path="/trips/:ticketId"
                            component={withTracker(Trips)}
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            path="/top-up/:ticketId"
                            component={withTracker(TopUp)}
                            props={childProps}
                        />
                        <AuthenticatedRoute
                            path="/top-up-confirmed/:customerTicketId"
                            component={withTracker(TopUpConfirmed)}
                            exact
                            props={childProps}
                        />
                        <Footer />
                    </div>
                </Fragment>
            )
        );
    }
}

export default App;
